var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorTagView = function (superClass) {
  extend(CoauthorTagView, superClass);
  function CoauthorTagView() {
    return CoauthorTagView.__super__.constructor.apply(this, arguments);
  }
  CoauthorTagView.prototype.initialize = function (options) {
    if (options.template != null) {
      this.template = options.template;
    }
    return CoauthorTagView.__super__.initialize.apply(this, arguments);
  };
  CoauthorTagView.prototype.render = function () {
    CoauthorTagView.__super__.render.apply(this, arguments);
    if (!this.model.get('locked')) {
      this.addEditView();
    }
    return this;
  };
  CoauthorTagView.prototype.addEditView = function () {
    return this.editView || (this.editView = new Works.CoauthorTagEdit({
      el: this.$el,
      model: this.model
    }));
  };
  CoauthorTagView.prototype.remove = function () {
    var ref;
    if ((ref = this.editView) != null) {
      ref.remove();
    }
    return CoauthorTagView.__super__.remove.apply(this, arguments);
  };
  return CoauthorTagView;
}(Works.SuggestableTagView);
window.extend = extend;
window.hasProp = hasProp;